import React from "react";
import { Box, Typography } from "@mui/material";
import { useTabs } from "./TabsContext";
import CandidatePersonalInfo from "../components/CandidatePersonalInfo";


export default function CandidateProfilePanels() {
  const { value } = useTabs();


  return (
    <Box sx={{ pt: 2 }}>
      {value === 0 && <CandidatePersonalInfo/>}
      {value === 1 && <Typography>📄 List of applications.</Typography>}
      {value === 2 && <Typography>🗓️ Interview schedule and results.</Typography>}
      {value === 3 && <Typography>🔔 Candidate notifications.</Typography>}
    </Box>
  );
}
